<template>
  <div class="container mt-5 px-2">
    <article class="message is-danger" v-if="!token">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>
    <div v-if="token">
      <h1 class="title is-4">Classes</h1>
      <div class="mt-3">
        <div v-if="waiting">
          <span class="icon is-medium is-size-4">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </div>
        <div v-else>
          <table class="table is-fullwidth is-hoverable">
            <thead>
              <tr>
                <th>#</th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('id')">Id</span>
                  <span class="icon" v-if="sortOption.field == 'id'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th>
                  <span class="is-clickable" @click="changeSortOption('nsId')">NS id</span>
                  <span class="icon" v-if="sortOption.field == 'nsId'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="data-column">
                  <span class="is-clickable" @click="changeSortOption('name')">Name</span>
                  <span class="icon" v-if="sortOption.field == 'name'">
                    <i class="fas" :class="{'fa-sort-up': sortOption.asc, 'fa-sort-down': !sortOption.asc}"></i>
                  </span>
                </th>
                <th class="action-column">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in showingItems" :key="'item-' + v.id" class="item-row" :class="{'has-background-white-ter': v.id == lastEditing}" :id="'item-'+v.id">
                <td>{{i+1}}</td>
                <td>{{v.id}}</td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.nsId}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.nsId">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-column">
                  <span v-if="!editingItem || editingItem.id != v.id">{{v.name}}</span>
                  <div class="field has-addons" v-if="editingItem && editingItem.id == v.id">
                    <div class="control">
                      <input class="input" type="text" v-model="editingItem.name">
                    </div>
                    <div class="control">
                      <button class="button is-info" :class="{'is-loading': updating}" @click="updateEditingItem">
                        <i class="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="action-column">
                  <span class="item-actions">
                    <a @click="setEditingItem(v)">
                      <span class="icon">
                        <i class="fas fa-edit"></i>
                      </span>
                    </a>
                    <a class="has-text-danger ml-3" @click="deleteItem(v)">
                      <span class="icon">
                        <i class="fas fa-trash"></i>
                      </span>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <button class="button" @click="addItem">
                    <span class="icon">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span>New</span>
                  </button>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div v-if="error" class="notification is-danger is-light">
        <button class="delete" @click="error=''"></button>
        {{error}}
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from 'dateformat'

export default {
  name: 'MyClasses',
  data () {
    return {
      error: '',
      waiting: false,
      items: [],
      sortOption: {
        field: 'id',
        asc: true,
      },
      editingItem: null,
      lastEditing: null,
      updating: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    token () {
      return this.$store.state.user.token
    },
    showingItems () {
      var sort = this.sortOption
      var sortedItems = [...this.items]
      sortedItems.sort((a, b) => {
        var va = a[sort.field]
        var vb = b[sort.field]
        if (sort.field == 'id') {
          return sort.asc ? va - vb : vb - va
        }
        if (!va && !vb){
          return 0
        }
        if(!va) {
          return sort.asc ? 1 : -1
        }
        if (!vb) {
          return sort.asc ? -1 : 1
        }
        return sort.asc ? va.localeCompare(vb) : vb.localeCompare(va)
      })
      return sortedItems
    },
  },
  methods: {
    getItems () {
      this.waiting = true
      this.$http.get(this.server + '/myapp/get-my-classes/').then(resp => {
        this.items = resp.body
        this.waiting = false
      }, err => {
        this.error = err.body
        this.waiting = false
      })
    },
    changeSortOption (field) {
      if (this.sortOption.field == field) {
        this.sortOption.asc = !this.sortOption.asc
        return
      }
      this.sortOption.field = field
    },
    setEditingItem (item) {
      if (this.editingItem && this.editingItem.id == item.id) {
        this.editingItem = null
        this.lastEditing = null
        return
      }
      this.editingItem = {...item}
      this.lastEditing = item.id
    },
    updateEditingItem () {
      this.updating = true
      this.$http.post(this.server + '/myapp/update-class/', this.editingItem).then(resp => {
        this.updating = false
        this.updateItemFromUpdating()
        this.scrollToItem(this.editingItem.id)
        this.editingItem = null
      }, err => {
        this.error = err.body
        this.updating = false
      })
    },
    deleteItem (item) {
      var confirm = {
        title: 'Delete class',
        message: 'Are you sure to remove this class: ' + JSON.stringify(item) + '?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.deleteItemConfirmed,
          args: [item]
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    deleteItemConfirmed (item) {
      this.$http.post(this.server + '/myapp/delete-class/', {id: item.id}).then(resp => {
        var index = this.items.findIndex(v => v.id == item.id)
        this.items.splice(index, 1)
      }, err => {
        this.error = err.body
      })
    },
    addItem () {
      var confirm = {
        title: 'Add class',
        message: 'Are you sure to add an empty class?',
        button: 'Yes, I am sure.',
        callback: {
          context: this,
          method: this.addItemConfirmed,
          args: []
        }
      }
      this.$store.commit('modals/openConfirmModal', confirm)
    },
    addItemConfirmed () {
      var message = {nsId: '', name: ''}
      this.$http.post(this.server + '/myapp/create-class/', message).then(resp => {
        var item = resp.body
        this.items.push(item)
        this.scrollToItem(item.id)
      }, err => {
        this.error = err.body
      })
    },
    updateItemFromUpdating() {
      var index = this.items.findIndex(v => v.id == this.editingItem.id)
      this.items.splice(index, 1, this.editingItem)
    },
    scrollToItem(itemId) {
      setTimeout(() => {
        const targetElement = document.getElementById("item-" + itemId);
        if (targetElement) {
          targetElement.scrollIntoView({ 
            behavior: "smooth", // "auto" for instant jump
            block: "start",     // Vertically aligns to "start", "center", "end", or "nearest"
            inline: "nearest"   // Horizontally aligns the element
          });
        }
      }, 1000)
    },
  },
  mounted () {
    this.$nextTick(function () {
      this.getItems()
    })
  },
}
</script>

<style scoped lang="scss">
.item-row .item-actions {
  display: none;
}

.item-row:hover .item-actions {
  display: block;
}

.action-column {
  width: 100px;
}

.data-column {
  min-width: 150px;
}
</style>
